import React from 'react';
import { AddButton } from '../AddButton';
import messages from '../ManageServices.messages';
import ScheduleIncrementsButton from './ScheduleIncrements/ScheduleIncrementsButtonContainer';

const ServicesAddButton = () => {
  return (
    <>
      <ScheduleIncrementsButton />
      <AddButton message={messages.addBtn.service} />
    </>
  );
};

export default ServicesAddButton;
